const loader = {
    loading: true,
    startLoader() {
        this.loading = true
    },
    stopLoader() {
        this.loading = false
    },
    genericLoader() {
        return `
            <div class="border border-grey-300 shadow rounded-md max-w-sm w-full mx-auto">
                <div class="animate-pulse flex">
                    <img class="bg-gray-200 aspect-w-1 aspect-h-1 p-10 pb-32" src="${process.env.MIX_CDN_IMAGE}placeholder-white.svg" alt="">
                </div>
            </div>
        `
    },
    fullPageLoader() {
        return `
            <div class="h-16 w-16 m-auto">
                <div class="loadingSpinner m-auto ease-linear rounded-full border-accu-loader h-16 w-16" style="z-index:101"></div>
                <svg class="h-8 w-8 mx-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 fill-current text-accu-dark" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 83.9 110.1">
                <path d="M42.4,0L0,97.4l2.5,12.7l11.1-6.7l8.4-19c11.7,9.2,28.2,9.2,39.8-0.1l4.2,9.5l4.2,9.6l11.1,6.7l2.5-12.7L42.4,0
                    z M41.9,76.3c-5.3,0-10.2-2.4-13.5-6.6l13.8-31.8l13.4,31.4C52.4,73.7,47.3,76.3,41.9,76.3L41.9,76.3z"/>
                </svg>
            </div>
        `
    },
}
document.addEventListener('alpine:init', () => {
    window.Alpine.data('loader', loader)
})

export default loader
